/* GUIDE DU CHAUSSANT (repense 2026-09-14) — bouton header "decouverte". Voir
   le commentaire en tete de snippets/guide-du-chaussant.liquid.

   2026-09-14i — REVELATION PROGRESSIVE DANS UNE SEULE VUE, identique mobile
   et desktop (retour utilisateur explicite, "pas sur un panneau") : Genre est
   visible des l'ouverture ; Stade reste cache tant que Genre n'est pas choisi
   puis apparait juste en dessous (les deux restent visibles ensemble, voir
   revealStade() pour l'animation d'apparition ajoutee le 2026-09-14j). Des
   que Stade est a son tour choisi, maybeNavigate() navigue immediatement —
   plus de bouton "Voir la selection" separe (2026-09-14h). Un CTA deja genre
   (banniere homepage, voir plus bas) masque le groupe Genre entierement et
   affiche direct le Stade.

   2026-09-29 — MESURE DE L'USAGE ET DES VENTES (demande utilisateur : savoir
   si le guide transforme). Trois ajouts, sans rien changer pour la cliente :
   1. attribut de panier "Guide du chaussant" (source · genre · stade) via
      /cart/update.js juste avant la navigation : il suit le panier jusqu'a la
      commande et apparait dans les informations complementaires de chaque
      commande Shopify (mesure independante des cookies et de GA4). Delai max
      1,2 s : la navigation part dans tous les cas.
   2. parametre d'URL guide=menu (bouton header) ou guide=accueil (CTA Fille /
      Garcon de la homepage) sur la collection d'arrivee : GA4 distingue ainsi
      le guide des filtres coches a la main (le widget des collections,
      assets/journey-selector.js, pose guide=collection).
   3. evenements Shopify.analytics.publish "guide_chaussant_ouvert" et
      "guide_chaussant_choix" : recus seulement par un pixel personnalise
      (Parametres > Evenements clients), optionnel, pour mesurer les abandons. */
(function () {
  "use strict";

  var TARGET_COLLECTION_URL = "/collections/toutes-nos-chaussures";
  var CART_ATTRIBUTE = "Guide du chaussant";
  var GENRE_LABEL = { FILLE: "Fille", GARCON: "Garçon" };

  function publish(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (e) {}
  }

  // Enregistre l'attribut de panier puis appelle done(), au plus tard apres
  // 1,2 s (reseau lent, erreur, panier indisponible : on navigue quand meme).
  function saveCartAttribute(value, done) {
    var finished = false;
    function go() {
      if (finished) return;
      finished = true;
      done();
    }
    setTimeout(go, 1200);
    try {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      var attributes = {};
      attributes[CART_ATTRIBUTE] = value;
      fetch(root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ attributes: attributes }),
        keepalive: true
      }).then(go, go);
    } catch (e) {
      go();
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    var trigger = document.querySelector("[data-gdc-trigger]");
    var dropdown = document.querySelector("[data-gdc-dropdown]");
    if (!trigger || !dropdown) return;

    var state = { cibles: null, stade_motricite_detail: null };
    var source = "menu";
    var navigating = false;
    var genreGroup = dropdown.querySelector('[data-gdc-key-group="cibles"]');
    var stadeGroup = dropdown.querySelector('[data-gdc-key-group="stade"]');

    function updateSelected() {
      dropdown.querySelectorAll("[data-gdc-key]").forEach(function (btn) {
        var key = btn.dataset.gdcKey;
        btn.dataset.selected = state[key] === btn.dataset.gdcValue ? "true" : "false";
      });
    }

    // 2026-09-14j — petite apparition douce (voir @keyframes gdc-group-reveal
    // dans assets/guide-du-chaussant.css) plutot qu'un pop-in brutal quand le
    // Stade se devoile. La classe est retiree puis reposee a chaque appel
    // (offsetWidth force un reflow) pour rejouer l'animation meme si le
    // groupe etait deja visible (ex: reouverture du modal).
    function revealStade() {
      stadeGroup.hidden = false;
      stadeGroup.classList.remove("gdc__group--reveal");
      stadeGroup.offsetWidth;
      stadeGroup.classList.add("gdc__group--reveal");
    }

    function hideStade() {
      stadeGroup.hidden = true;
      stadeGroup.classList.remove("gdc__group--reveal");
    }

    // 2026-09-14h — remplace l'ancien bouton "Voir la selection" : appelee
    // apres chaque clic sur le Stade, navigue des que les 2 criteres requis
    // sont reunis (le dernier clic vaut validation).
    // 2026-09-29 — ajoute guide=<source>, l'attribut de panier et l'evenement
    // guide_chaussant_choix (voir l'en-tete du fichier).
    function maybeNavigate() {
      if (!(state.cibles && state.stade_motricite_detail)) return;
      if (navigating) return;
      navigating = true;
      var url = new URL(TARGET_COLLECTION_URL, window.location.origin);
      url.searchParams.set("filter.p.m.catalogue.cibles", state.cibles);
      url.searchParams.set("filter.p.m.catalogue.stade_motricite_detail", state.stade_motricite_detail);
      url.searchParams.set("guide", source);
      var genre = GENRE_LABEL[state.cibles] || state.cibles;
      publish("guide_chaussant_choix", { source: source, genre: genre, stade: state.stade_motricite_detail });
      saveCartAttribute(source + " · " + genre + " · " + state.stade_motricite_detail, function () {
        window.location.href = url.pathname + url.search;
      });
    }

    function isOpen() {
      return !dropdown.hidden;
    }

    // presetGenre (optionnel) : "FILLE"/"GARCON" quand l'ouverture vient d'un
    // CTA deja genre (voir le listener #gdc-fille/#gdc-garcon plus bas) — dans
    // ce cas, le groupe Genre est masque entierement et le Stade apparait
    // direct. Une ouverture normale (sans argument, bouton header "Me guider")
    // retrouve toujours le flux complet Genre -> Stade.
    function open(presetGenre) {
      dropdown.hidden = false;
      trigger.setAttribute("aria-expanded", "true");
      source = presetGenre ? "accueil" : "menu";
      publish("guide_chaussant_ouvert", { source: source });
      if (presetGenre) {
        state.cibles = presetGenre;
        genreGroup.hidden = true;
        revealStade();
      } else {
        genreGroup.hidden = false;
        if (state.cibles) {
          revealStade();
        } else {
          hideStade();
        }
      }
      updateSelected();
    }

    function close() {
      dropdown.hidden = true;
      trigger.setAttribute("aria-expanded", "false");
    }

    trigger.addEventListener("click", function () {
      if (isOpen()) {
        close();
      } else {
        open();
      }
    });
    document.addEventListener("click", function (e) {
      if (!isOpen()) return;
      if (trigger.contains(e.target) || dropdown.contains(e.target)) return;
      close();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && isOpen()) close();
    });

    dropdown.querySelectorAll('[data-gdc-key="cibles"]').forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.cibles = state.cibles === btn.dataset.gdcValue ? null : btn.dataset.gdcValue;
        updateSelected();
        if (state.cibles) {
          revealStade();
        } else {
          hideStade();
        }
      });
    });

    dropdown.querySelectorAll('[data-gdc-key="stade_motricite_detail"]').forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.stade_motricite_detail =
          state.stade_motricite_detail === btn.dataset.gdcValue ? null : btn.dataset.gdcValue;
        updateSelected();
        if (state.stade_motricite_detail != null) maybeNavigate();
      });
    });

    // 2026-09-14f/g — CTA "Fille"/"Garcon" de la banniere homepage
    // (templates/index.json, section hero > button_url_1/2 pointent vers les
    // ancres #gdc-fille / #gdc-garcon plutot que vers une vraie URL) : le
    // genre est deja choisi par ce clic. Delegation sur document : ces liens
    // vivent dans une tout autre section du DOM, hors de .gdc-dropdown.
    document.addEventListener("click", function (e) {
      var cta = e.target.closest('a[href="#gdc-fille"], a[href="#gdc-garcon"]');
      if (!cta) return;
      e.preventDefault();
      open(cta.getAttribute("href") === "#gdc-fille" ? "FILLE" : "GARCON");
    });
  });
})();
